import { inject, injectable } from 'inversify';
import type { IBoxViewModelModifier } from '@/components/boxes/common/interfaces.ts';
import { TYPES } from '@/engine/ioc';
import type { ViewsService } from '@/engine/app/Views.service.ts';
import type { IViewItemsViewModelController } from '@/engine/app/interfaces.ts';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm.ts';

@injectable()
export class BoxViewModelModifier implements IBoxViewModelModifier {
  private readonly _viewsService: ViewsService;

  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _viVmController: IViewItemsViewModelController;

  public constructor(
    @inject(TYPES.ViewsService) viewsService: ViewsService,
    @inject(TYPES.IViewItemsViewModelController)
    viVmController: IViewItemsViewModelController,
    @inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm
  ) {
    this._viewsService = viewsService;
    this._planningAlgorithm = planningAlgorithm;
    this._viVmController = viVmController;
  }

  public setViewModelVisibility(descriptor: string, isVisible: boolean): void {
    const relatedParentObjectViewModel = this._viewsService.currentView
      ?.getObjects()
      .find((o) => o.attachments.at(0) === descriptor);

    this._viVmController.setViewModelVisibility(descriptor, isVisible, relatedParentObjectViewModel);
  }

  public setViewModelSelection(descriptor: string, isSelected: boolean): void {
    if (this._planningAlgorithm.getIValue(descriptor) === undefined) return;

    const relatedParentObjectViewModel = this._viewsService.currentView
      ?.getObjects()
      .find((o) => o.attachments.at(0) === descriptor);

    this._viVmController.setViewModelSelection(descriptor, isSelected, relatedParentObjectViewModel);
  }
}
